<template>
  <section ref="section" class="-visibility-auto">
    <h2 class="a11y-sr-only" v-text="item.title"></h2>
    <div class="container text-center">
      <div class="row justify-content-center">
        <div class="col-12 col-md-10">
          <Observer name="fade-up" @enter="enter" v-if="item.imageA || item.imageB">
            <parallax ref="parallax" :from="{ y: -100 }" :to="{ y: 100 }" v-if="item.imageA">
              <img
                ref="pictureA"
                :src="imageA"
                :alt="item.imageB ? item.imageB.alt : ''"
                slot-scope="{ parallax }"
                :style="`transform: translate3d(0px, ${parallax && parallax.y ? Math.round(parallax.y) : 0}px, 0px)`"
                loading="lazy"
              />
            </parallax>
            <parallax ref="parallax" :from="{ y: 100 }" :to="{ y: -100 }" v-if="item.imageB">
              <img
                ref="pictureB"
                :src="imageB"
                :alt="item.imageB ? item.imageB.alt : ''"
                slot-scope="{ parallax }"
                :style="`transform: translate3d(0px, ${parallax && parallax.y ? Math.round(parallax.y) : 0}px, 0px)`"
                loading="lazy"
              />
            </parallax>
          </Observer>
          <Observer name="fade-up">
            <h2 class="h3 title -upper" v-if="item.title" aria-hidden="true" v-html="item.title" data-aos="fade-in"></h2>
            <div v-if="item.text" v-html="item.text" class="wysiwyg" data-aos="fade-in"></div>
          </Observer>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { Parallax } from 'leaps/dist/leaps'
import { ReadyHook } from 'vue-asyncready'
import { currentStoreView } from '@vue-storefront/core/lib/multistore'
import ImageManager from 'vue-storefront-prismic-ssr/utilities/ImageManager'
export default {
  props: ['item', 'items', 'pagePosition', 'siblings-components'],
  name: 'StaggeredVisuals',
  mixins: [ReadyHook],
  components: {
    Parallax,
  },
  data() {
    return {
      appeared: false,
    }
  },
  computed: {
    localizedUrl() {
      return currentStoreView().url || ''
    },
    imageA() {
      return ImageManager.getLowDefinition(this.item.imageA.url, 400, 1.5)
    },
    imageB() {
      return ImageManager.getLowDefinition(this.item.imageB.url, 400, 1.5)
    },
  },
  methods: {
    enter() {
      if (!this.appeared) {
        this.$refs.section.classList.remove('-visibility-auto')
        this.$refs.parallax.updateConfig()
        this.$refs.parallax.update()
        this.appeared = true
        if (this.$refs.pictureA) this.$refs.pictureA.srcset = ImageManager.getSrcSet(this.item.imageA.url, 1200, 400, 100, 1.5)
        if (this.$refs.pictureB) this.$refs.pictureB.srcset = ImageManager.getSrcSet(this.item.imageB.url, 1200, 400, 100, 1.5)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~theme/css/core';

.-icons .title {
  display: inline;
  font-size: em(24);
  font-weight: normal;
  color: var(--zenith-white) !important;
  background: var(--zenith-theme-primary) !important;
  box-shadow: -2px 0px 0px 6px var(--zenith-theme-primary);

  & + div {
    margin-top: 3rem;
  }
}

section {
  margin: 10rem 0 10rem;

  @include bp(max md) {
    margin-top: 6rem;
    margin-bottom: 6rem;
  }
}

.obs:first-child {
  margin-bottom: 14rem;
  @include bp(max md) {
    margin-bottom: 2rem;
  }

  img {
    width: calc(49% - 4rem);
    margin: 0 2rem;

    @include bp(max md) {
      width: 100%;
      margin: 0 0 2rem;
      transform: none !important;
    }
  }
}

.obs:last-child {
  max-width: 65rem;
  margin: auto;
}

.title {
  margin-bottom: 3rem;
  color: var(--zenith-theme-primary);
}

.wysiwyg {
  font-size: em(18);
  line-height: em(25, 18);
  letter-spacing: em(0.2, 18);
  color: var(--zenith-component-title-text-center-text);

  @include bp(max md) {
    font-size: em(16);
    line-height: em(22, 16);
    letter-spacing: em(0.2, 16);
  }

  /deep/ ul,
  /deep/ ol {
    padding: 0;
    margin-bottom: 2rem;
    font-size: em(18, 18);
    line-height: em(25, 18);
    letter-spacing: em(0.2, 18);
    list-style: none;

    li:before {
      content: '-';
      margin-right: 1.4rem;
    }

    @include bp(max md) {
      font-size: em(16, 16);
      font-weight: normal;
      line-height: em(22, 16);
      letter-spacing: em(0.2, 16);
    }
  }

  /deep/ a {
    text-decoration: underline;
    color: var(--zenith-component-title-text-center-text);
  }

  /deep/ p {
    color: var(--zenith-component-title-text-center-text);
    font-size: em(18, 18);
    font-weight: normal;
    line-height: em(25, 18);
    letter-spacing: em(0.2, 18);
    margin-bottom: 2rem;

    @include bp(max md) {
      font-size: em(16, 16);
      font-weight: normal;
      line-height: em(22, 16);
      letter-spacing: em(0.2, 16);
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
